<script setup>
import FormTextarea from '../../../../components/Forms/FormTextarea.vue';

defineProps({
    question: {
        type: Object,
        required: true,
    },
});
const value = defineModel({ type: [Object], required: true });
</script>

<template>
    <div>
        <FormTextarea
            v-model="value.text"
            :required="question.is_required"
            :placeholder="question.is_required ? '' : $t('messages.survey_question_not_required_placeholder')"
            class="w-full"
            :name="`question_${question.id}`"
        />
    </div>
</template>
